import { useCallback, useContext } from 'react';

import {
  CHF_CLIENTS_FILTER,
  CHF_MAX_AGE,
  CHF_MIN_AGE,
} from '@app/pages/Clients/ClientsList/constants/filterKeysAndIds';
import { ClientFiltersContext } from '@app/providers';

import { RangeWithStartAndEnd } from '.';

const MIN_AGE = 0;
const MAX_AGE = 150;

export const ClientsAge = ({
  includedFiltersIndex,
  labelClassName,
}: {
  includedFiltersIndex: number;
  labelClassName: string;
}) => {
  const { filters, setFilters } = useContext(ClientFiltersContext);
  const Values = filters.ClientsFilter?.[includedFiltersIndex]?.Values?.[0];

  const handleChange = useCallback(
    (value: string | number | null, filterGroupKey: string): void => {
      setFilters({
        ...(filters || []),
        ClientsFilter: [
          ...(filters.ClientsFilter.filter(
            (_, index) => index !== includedFiltersIndex
          ) || []),
          {
            ...filters.ClientsFilter?.[includedFiltersIndex],
            Values: [
              {
                ...Values,
                [filterGroupKey]: value || value === 0 ? Number(value) : null,
              },
            ],
          },
        ],
      });
    },
    [filters, includedFiltersIndex, setFilters, Values]
  );

  return (
    <RangeWithStartAndEnd
      labelClassName={labelClassName}
      minValue={Values?.MinAge}
      maxValue={Values?.MaxAge}
      filterGroupKey={CHF_CLIENTS_FILTER}
      filterUnitKey={CHF_MIN_AGE}
      filterUnitMaxKey={CHF_MAX_AGE}
      filterGroupIndex={includedFiltersIndex}
      handleMinChange={(value) => handleChange(value, 'MinAge')}
      handleMaxChange={(value) => handleChange(value, 'MaxAge')}
      min={MIN_AGE}
      max={MAX_AGE}
      tip={`От ${MIN_AGE} до ${MAX_AGE} лет`}
    />
  );
};
